import * as React from "react";
import moment from "moment";
import { IGridViewFilter } from "./IGridViewFilter";
import { RioIcon, RioDateHelpers, RioResources, RioIconButton, RioDatePicker } from "rio.react.all";
import $ from "jquery";

export class DateFilter implements IGridViewFilter {
    constructor(private callback: () => void, private closeFilter: () => void, private dateFormat: string, private includeTime: boolean) {
    }

    dateFrom: string = "";
    dateTo: string = "";

    validate(value: string | number): boolean {
        if (!this.filterActive()) {
            return true; //if filter cleared show all
        } else if (!!value &&
            ((value >= this.dateFrom && value <= this.dateTo) ||
                (value >= this.dateFrom && !this.dateTo) ||
                (!this.dateFrom && value <= this.dateTo))) {
            return true;
        } else {
            return false;
        }
    }

    private dateFilterComponent = React.createRef<DateFilterComponent>();

    render() {
        return (
            <DateFilterComponent
                ref={this.dateFilterComponent}
                dateFormat={this.dateFormat}
                onFromChanged={(dateFrom) => {
                    this.dateFrom = (this.includeTime || !dateFrom) ? dateFrom : moment(dateFrom).format("YYYY-MM-DD");
                    this.callback();
                }}
                onToChanged={(dateTo) => {
                    this.dateTo = (this.includeTime || !dateTo) ? dateTo : moment(dateTo).add(1, "day").subtract(1, "second").format("YYYY-MM-DDTHH:mm:ss");
                    this.callback();
                }}
                includeTime={this.includeTime}
                closeFilter={this.closeFilter}
            />
        );
    }

    clearFilter() {
        this.dateFilterComponent.current.clearFilter();
    }

    filterActive(): boolean {
        if (!!this.dateFrom || !!this.dateTo) {
            return true;
        } else {
            return false;
        }
    }
}

interface IDateFilterComponentProps {
    onFromChanged: (dateFrom: string) => void;
    onToChanged: (dateTo: string) => void; //Need 2 functions because of race conditions when clearing filters
    dateFormat: string;
    includeTime: boolean;
    closeFilter: () => void;
}

interface IDateFilterComponentState {
    dateFrom: string;
    dateTo: string;
}

class DateFilterComponent extends React.Component<IDateFilterComponentProps, IDateFilterComponentState> {
    constructor(props: Readonly<IDateFilterComponentProps>) {
        super(props);

        this.state = {
            dateFrom: "",
            dateTo: ""
        };

    }

    private filterWrapperElement = React.createRef<HTMLTableElement>();
    private dateFromPicker = React.createRef<RioDatePicker>();
    private dateToPicker = React.createRef<RioDatePicker>();
    private dateFormat = !!this.props.dateFormat ? this.props.dateFormat : "DD/MM/YYYY"

    render() {
        return (
            <table ref={this.filterWrapperElement} className="filterWrapper">
                <tbody>
                    <tr className="closeButtonRow">
                        <td></td>
                        <td></td>
                        <td>
                            <RioIconButton resource={RioResources.find("FilterClose")} hideText={true} onClick={() => this.props.closeFilter()} hasPermission={true} />
                        </td>
                    </tr>
                    <tr className="filterInput">
                        <td>
                            <span>{RioResources.find("From").text}:</span>
                        </td>
                        <td>
                            <RioDatePicker ref={this.dateFromPicker} name="From" validator={null} from={this.state.dateFrom} onChange={(from: string, to: string) => { this.handleFromChanged(from) }} onInputChange={(from: string, to: string) => { this.handleFromChangedByInput(from) }} time={this.props.includeTime} dateFormat={this.dateFormat} asUtc={true} />
                        </td>
                        <td>
                            <button className="clearFilterButton" onClick={() => this.dateFromPicker.current.clear()}>
                                <RioIcon resource={RioResources.find("ClearFilterIcon")} />
                            </button>
                        </td>
                    </tr>
                    <tr className="filterInput">
                        <td>
                            <span>{RioResources.find("To").text}:</span>
                        </td>
                        <td>
                            <RioDatePicker ref={this.dateToPicker} name="To" validator={null} from={this.state.dateTo} onChange={(from: string, to: string) => { this.handleToChanged(from) }} onInputChange={(from: string, to: string) => { this.handleToChangedByInput(from) }} time={this.props.includeTime} dateFormat={this.dateFormat} asUtc={true} />
                        </td>
                        <td>
                            <button className="clearFilterButton" onClick={() => this.dateToPicker.current.clear()}>
                                <RioIcon resource={RioResources.find("ClearFilterIcon")} />
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    }

    handleFromChanged(date: string) {
        this.setState({
            dateFrom: date
        });
        this.props.onFromChanged(date);
        if (!!date && !!this.state.dateTo && date > this.state.dateTo) { //if from > to, set to to be from
            this.dateToPicker.current.handleInputValueChanged(RioDateHelpers.toDateFormat(date, this.dateFormat));
        }
    }

    handleFromChangedByInput(date: string) {
        this.setState({
            dateFrom: date
        });
        this.props.onFromChanged(date);
    }

    handleToChanged(date: string) {
        this.setState({
            dateTo: date,
        });
        this.props.onToChanged(date);
        if (!!date && !!this.state.dateFrom && this.state.dateFrom > date) { //if from > to, set from to be to
            this.dateFromPicker.current.handleInputValueChanged(RioDateHelpers.toDateFormat(date, this.dateFormat));
        }
    }

    handleToChangedByInput(date: string) {
        this.setState({
            dateTo: date,
        });
        this.props.onToChanged(date);
    }

    componentDidUpdate() {
        this.checkIfOffScreen();
    }

    checkIfOffScreen() {
        if (!!this.filterWrapperElement.current) {
            const filterWindowElement = this.filterWrapperElement.current.parentElement;
            const filterWindowElementPosition = filterWindowElement.getBoundingClientRect();

            const tableRowElement = filterWindowElement.parentElement.parentElement;
            const tableRowElementPosition = tableRowElement.getBoundingClientRect();

            if (filterWindowElementPosition.right > tableRowElementPosition.right) {
                $(filterWindowElement).addClass("right");
            }
        }
    }

    clearFilter() {
        this.dateFromPicker.current.clear();
        this.dateToPicker.current.clear();
    }

}